import { getAttributes, toString } from '@carbon/icon-helpers';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export interface UserInterfacePluginParameters {
  command: string;
  label: string;
  icon: Record<string, unknown>;
  keystroke?: string;
  params?: Record<string, unknown>;
}

export const createUIPlugin = ({
  command: command_key,
  label,
  icon,
  keystroke,
  params: command_parameters,
}: UserInterfacePluginParameters): typeof Plugin =>
  class extends Plugin {
    init() {
      const { editor } = this;
      const { t } = editor;

      editor.ui.componentFactory.add(command_key, (locale) => {
        const command = editor.commands.get(command_key);
        const view = new ButtonView(locale);

        view.set({
          label: t(label),
          icon: toString({
            ...icon,
            attrs: getAttributes(icon.attrs),
          }),
          keystroke,
          tooltip: true,
          isToggleable: true,
        });

        view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');

        // Execute command.
        this.listenTo(view, 'execute', () => {
          editor.execute(command_key, command_parameters);
          editor.editing.view.focus();
        });

        return view;
      });
    }
  };
